import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetProductoresProps } from "@/services/accounts.service";
import { z } from "zod";

export const establishmentFilterSchema = z.object({
  account_number: z.any().optional(),
  account_type: z.any().optional(),
  commercial_zone: z.any().optional(),
  locality: z.any().optional(),
  social_reason: z.any().optional(),
});

export interface EstablishmentFRProps {
  account_number?: Option;
  account_type?: string;
  commercial_zone?: string;
  locality?: string;
  social_reason?: string;
}

export const getEstablishmentFilterRequest = (
  event: EstablishmentFRProps,
): Partial<GetProductoresProps> => {
  return {
    ...(event?.account_number?.value
      ? { NroCuenta: parseInt(String(event.account_number.value)) }
      : {}),
    ...(event?.account_type ? { TipoDeCuenta: event.account_type } : {}),
    ...(event?.commercial_zone ? { ZonaComercial: event.commercial_zone } : {}),
    ...(event?.locality ? { Localidad: event.locality } : {}),
    ...(event?.social_reason ? { RazonSocial: event.social_reason } : {}),
  };
};
